import { DeviceTypes } from '../actions/deviceAction';

const defaultState = {
  isLoading: true,
  isLoadingVirtualDevice: true,
  isLoadingDxcGear: true,
  listCardDevice: [],
  isDxcGear: true,
  isOpenLoadingAckowledge: false,
  isOpenSideSheet: false,
  dataTicketDetail: {},
  listNewAssetRequest: [],
  isLoadingSideSheet: false,
  listVirtual: [],
  listDeviceAvailable: []
};

const deviceReducer = (state = defaultState, action: any) => {
  const { listCardDevice, isDxcGear, isOpenLoadingAckowledge, dataTicketDetail, isOpenSideSheet, listNewAssetRequest, isLoadingSideSheet, listVirtual, listDeviceAvailable } = action;

  switch (action.type) {
    case DeviceTypes.SET_LIST_DEVICE_AVAILABLE_SUCCESS:
      return {
        ...state,
        listDeviceAvailable
      }
    case DeviceTypes.GET_LIST_CARD_DEVICE_SUCCESS:
      return {
        ...state,
        listCardDevice,
        isLoading: false,
        isOpenLoadingAckowledge: false
      }
    case DeviceTypes.GET_LIST_CARD_DEVICE_FAIL:
      return {
        ...state,
        isLoading: false,
      }

    case DeviceTypes.GET_NEW_DEVICE_ASSET_REQUESTS_SUCCESS:
      return {
        ...state,
        listNewAssetRequest,
      }
      
    case DeviceTypes.CHECK_USER_DXC_GEAR_SUCCESS:
      return {
        ...state,
        isLoadingDxcGear: false,
        isDxcGear
      }

    case DeviceTypes.CHECK_USER_DXC_GEAR_FAIL:
      return {
        ...state,
        isLoadingDxcGear: false,
      }

    case DeviceTypes.OPEN_LOADING_ACKNOWLEDGE:
      return {
        ...state,
        isOpenLoadingAckowledge
      }
    case DeviceTypes.LOADING_SIDE_SHEET:
      return {
        ...state,
        isLoadingSideSheet
      }
      
    case DeviceTypes.GET_DATA_TICKET_DETAIL_SUCCESS:
      return {
        ...state,
        isLoadingSideSheet: false,
        isOpenSideSheet: true,
        dataTicketDetail
      }

    case DeviceTypes.CLOSE_SIDE_SHEET:
      return {
        ...state,
        isOpenSideSheet
      } 

    case DeviceTypes.GET_LIST_VIRTUAL_DESKTOP_SUCCESS:
      return {
        ...state,
        listVirtual,
        isLoadingVirtualDevice: false,
      }
    case DeviceTypes.CLEAR_ALL_DEVICES:
      return {
        ...state,
        listCardDevice: [],
        listVirtual: [],
      }
  }
  return state;
};

export default deviceReducer;